export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#00D9FF] text-gray-900 py-12 sm:py-16 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-8 sm:mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/6c0747ed3ed7d95f4444c2a7207439a8.jpeg"
              alt="The Auto Salon"
              className="h-12 sm:h-14 w-auto mb-4"
            />
            <p className="text-sm sm:text-base text-gray-800">
              Professional automotive detailing and reconditioning services in Wichita, KS.
            </p>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm sm:text-base text-gray-800 hover:text-white transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm sm:text-base text-gray-800 hover:text-white transition-colors cursor-pointer"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('gallery')}
                  className="text-sm sm:text-base text-gray-800 hover:text-white transition-colors cursor-pointer"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm sm:text-base text-gray-800 hover:text-white transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4">Contact Info</h3>
            <ul className="space-y-3 text-sm sm:text-base">
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line flex-shrink-0 mt-1"></i>
                <span className="text-gray-800">246 N Mathewson, Wichita, KS</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-phone-line flex-shrink-0"></i>
                <a href="tel:+13163007524" className="text-gray-800 hover:text-white transition-colors">
                  (316) 300-7524
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-mail-line flex-shrink-0 mt-1"></i>
                <a href="mailto:darnelmd@icloud.com" className="text-gray-800 hover:text-white transition-colors break-all">
                  darnelmd@icloud.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4">Business Hours</h3>
            <ul className="space-y-2 text-sm sm:text-base text-gray-800">
              <li>Monday - Friday:<br />7:00 AM - 6:00 PM</li>
              <li>Saturday:<br />7:00 AM - 4:00 PM</li>
              <li>Sunday: Closed</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800/20 pt-6 sm:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs sm:text-sm text-gray-800 text-center sm:text-left">
            © {new Date().getFullYear()} The Auto Salon. All rights reserved.
          </p>
          <div className="flex items-center space-x-4">
            <a
              href="https://www.facebook.com/profile.php?id=100057565924513"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-gray-900 rounded-full text-white hover:bg-gray-800 transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-base sm:text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
